/**
 * What counts as a case's STL, in one place.
 *
 * The file itself is never moved through the app — a case is an upper
 * and a lower arch and routinely runs to hundreds of megabytes, so it is
 * hosted elsewhere and the case carries a link to it. This is only used
 * to mark up attachments on messages sent back when the chat did take
 * files, so an STL among them still reads as the deliverable rather than
 * as any old attachment.
 */

/** A raw mesh, or the archive an upper and a lower arch arrive in. */
export const STL_EXTENSIONS = ['stl', 'zip', 'rar', '7z'];

export const extensionOf = (name) => (name || '').split('.').pop().toLowerCase();

export const isStlFile = (name) => STL_EXTENSIONS.includes(extensionOf(name));
